var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_Set",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#37474F;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:#FFB300;stroke:#37474F;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st2{fill:#90CAF9;stroke:#37474F;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{fill:#FFFFFF;stroke:#37474F;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st4{fill:#FF7043;stroke:#37474F;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st5{fill:#9CCC65;stroke:#37474F;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st6{fill:#37474F;}\n\t.st7{fill:#37474F;stroke:#37474F;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st8{fill:none;stroke:#37474F;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Business_Man"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 54,
    y1: 54,
    x2: 59,
    y2: 54
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 61,
    y1: 54,
    x2: 62,
    y2: 54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 10,
    y1: 54,
    x2: 5,
    y2: 54
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 3,
    y1: 54,
    x2: 2,
    y2: 54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43,20.5c-0.1,0-0.2,0-0.3,0C41.6,15.6,37.2,12,32,12s-9.6,3.6-10.7,8.5c-0.1,0-0.2,0-0.3,0 c-1.4,0-2.5,1.1-2.5,2.5s1.1,2.5,2.5,2.5c0.1,0,0.2,0,0.3,0C22.4,30.4,26.8,34,32,34s9.6-3.6,10.7-8.5c0.1,0,0.2,0,0.3,0 c1.4,0,2.5-1.1,2.5-2.5S44.4,20.5,43,20.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22,22h-0.5v-6.5h3v4C24.5,20.9,23.4,22,22,22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.5,15.4v4.1c0,1.4,1.1,2.5,2.5,2.5h0.5v-7.9C41.7,14.8,40.7,15.3,39.5,15.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 35.5,
    cy: 21.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 28.5,
    cy: 21.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.5,26.5c2,2,5.1,2,7.1,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39,15.5H21.5v0c0-4.1,3.4-7.5,7.5-7.5h5.2c2.2,0,4.3-0.5,6.3-1.4L44,5v5.5C44,13.3,41.8,15.5,39,15.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "34.5,56.1 32,59 29.5,56.1 31,41 33,41  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 22,
    y1: 59,
    x2: 22,
    y2: 49
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 42,
    y1: 59,
    x2: 42,
    y2: 49
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.5,59l-2-22.9l-7,3c-2.8,1.2-4.5,3.9-4.5,6.9V59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50,59V45.9c0-3-1.8-5.7-4.5-6.9l-7-3l-2,22.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "25.9,41 30,38 28,35 25.5,36.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "38.1,41 34,38 36,35 38.5,36.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M33,41h-2c-0.6,0-1-0.4-1-1v-1c0-0.6,0.4-1,1-1h2c0.6,0,1,0.4,1,1v1C34,40.6,33.6,41,33,41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32,34c-1.4,0-2.8-0.3-4-0.8V35l2.2,3.4c0.2-0.2,0.4-0.4,0.8-0.4h2c0.3,0,0.6,0.1,0.8,0.4L36,35v-1.8 C34.8,33.7,33.4,34,32,34z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7,29l1.7-0.6c0.8-0.3,1.5-0.9,1.8-1.8L11,25l0.6,1.7c0.3,0.8,0.9,1.5,1.8,1.8L15,29l-1.7,0.6 c-0.8,0.3-1.5,0.9-1.8,1.8L11,33l-0.6-1.7c-0.3-0.8-0.9-1.5-1.8-1.8L7,29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52,36.1l1.7-0.6c0.8-0.3,1.5-0.9,1.8-1.8l0.6-1.7l0.6,1.7c0.3,0.8,0.9,1.5,1.8,1.8l1.7,0.6l-1.7,0.6 c-0.8,0.3-1.5,0.9-1.8,1.8L56,40.1l-0.6-1.7c-0.3-0.8-0.9-1.5-1.8-1.8L52,36.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/인사노무.1002a75f433903fd4f7adeee3300d110.svg";
export { ForwardRef as ReactComponent };